  <div [matTooltip]="getTooltip()" matTooltipPosition="right">
    <button matIconButton *ngIf="(flagService.getFlags$() | async)?.[FeatureFlags.BEFORE_AFTER] && !discreteEnabled"
            class="mat-icon-toggle-button" [disabled]="disable" type="button" [class.selected]="active" (click)="toggleSwipe()">
      <mat-icon>flip</mat-icon>
    </button>
  </div>
